import { useEffect, useState } from 'react'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'

function EmployeeStillOnboardingDialog ({ openDialog }: { openDialog: boolean }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(openDialog)
  }, [openDialog])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className='h2'>Onboarding in progress</DialogTitle>
          <DialogDescription className='DialogDescription'>
            This employee has not yet signed up for a Thatch account. Once they have signed up and begin onboarding, you will be able to
            see their details as they progress through benefits onboarding.
          </DialogDescription>
        </DialogHeader>
        <div style={{ display: 'flex', marginTop: 25, justifyContent: 'flex-end' }}>
          <DialogClose asChild>
            <button className='button'>Ok</button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EmployeeStillOnboardingDialog
